module.exports = __webpack_public_path__ + "img/五所.5380a95f.jpg";